import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { PlanRoutingModule } from './plan-routing.module';
import { PlanDetailComponent } from './plan-detail/plan-detail.component';
import { ViewEFL } from './plan-detail/plan-detail.component';
import { PlanService } from './plan.service';
import { PipeModule } from '../shared/pipe/pipe.module';
import { CdkTableModule } from '@angular/cdk/table';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { 
  MatAutocompleteModule,
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatProgressBarModule } from '@angular/material';
@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    PlanRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    PipeModule.forRoot(),
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ],
  bootstrap: [ViewEFL],
  providers: [PlanService],
  declarations: [ 
    PlanDetailComponent,
    ViewEFL
  ]
})
export class PlanModule { }



// WEBPACK FOOTER //
// ./src/app/plan/plan.module.ts